import createAxiosInstance from "../utils/apiUtils";

import { userBaseUrl } from "../constants/Constants";
// import { LOCAL } from "constants/Constants";

const instance = createAxiosInstance({
	baseURL: userBaseUrl + "/integrations/",
});

const bufferInstance = createAxiosInstance({
	baseURL: userBaseUrl + "/integrations/",
	// baseURL: LOCAL + "/",
	responseType: "arraybuffer",
});

// const localInstance = createAxiosInstance({
// 	baseURL: LOCAL + "/",
// });

export const getVehicleTypes = async (locationID) => {
	return await instance.get(
		`/tec-assured/get-vehicle-types?location_id=${locationID}`
	);
};
export const getVehicleInputProperties = async (body) => {
	return await instance.post(
		`/tec-assured/get-vehicle-input-properties/`,
		body
	);
};

export const rateVehicle = async (body) => {
	return await instance.post(`/tec-assured/rate-vehicle/`, body);
};

export const createAgreement = async (body) => {
	return await instance.post(`/tec-assured/create-agreement/`, body);
};

export const getProductProperties = async (body) => {
	return await instance.post(`/tec-assured/get-product-properties/`, body);
};

export const initialAgreementDocuments = async (body) => {
	return await instance.post(`/tec-assured/agreement-documents/`, body);
};

export const finalizeAgreement = async (body) => {
	return await instance.post(`/tec-assured/finalize-agreement/`, body);
};

export const getDocument = async (body) => {
	return await bufferInstance.post(`/tec-assured/get-document/`, body);
};
